export const LOGO = "https://cdn.prod.website-files.com/5ee732bebd9839b494ff27cd/5ee732bebd98393d75ff281d_580b57fcd9996e24bc43c529.png";

export const USERICON = "https://wallpapers.com/images/hd/netflix-profile-pictures-1000-x-1000-qo9h82134t9nv0j0.jpg";

export const USER_AVATAR = "https://wallpapers.com/images/hd/netflix-profile-pictures-1000-x-1000-qo9h82134t9nv0j0.jpg";

export const BG_URL = "https://www.notebookcheck.net/fileadmin/Notebooks/News/_nc3/netflixteaser.png";

export const SUPPORTED_LANGUAGES =[{identifier: "en", name: "English"}, {identifier: "hindi", name: "Hindi"}, {identifier: "spanish", name: "Spanish"}]

export const OPEN_AI_KEY = "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";


export const API_OPTIONS  = {
    method: "GET",
    headers: {
      accept: "application/json",
      Authorization: "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIwOGMyNzZhMjBiYWJlZDk4YTBlZGYzYmNkNGYzMGYwOCIsIm5iZiI6MTczMTYwNjI5OS44MTg4NzkxLCJzdWIiOiI2NzM2MzVjM2Q2M2ZlZDU4MjZjZjMwNjkiLCJzY29wZXMiOlsiYXBpX3JlYWQiXSwidmVyc2lvbiI6MX0.BJLw0kvmrQeUQLhQRkdpTDV-g8-auoP9noASsceBbpc"
    }
  };

  export const IMG_CDN_URL = "https://image.tmdb.org/t/p/w500"